$shm_hitalama_map_widget_presets_page $mol_page
	title \Добавить виджет
	body /
		<= Add_widget_menu $shm_hitalama_map_page_contextmenu
			Map_page <= Map_page $shm_hitalama_map_page
			add_pos <= add_pos /
